import React, { ComponentType } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledBookButtonProps } from '../../styledComponents';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectOptions } from '../../../../../../store/features/options';

export type BookButtonProps = {
  bookingOpen: boolean;
  optionIndex?: number;
  bookingClosedText?: string;
  bookingLinkOverride?: string;
  bookingButtonTextOverride?: string;
  as: ComponentType<StyledBookButtonProps>;
  testId: string;
};

export function BookButton(props: BookButtonProps) {
  const {
    bookingLinkOverride,
    bookingButtonTextOverride,
    bookingClosedText,
    bookingOpen,
    optionIndex,
    as: Component,
    testId,
  } = props;
  const { t } = useTranslation();
  const { newPaymentJourneyEnabled } = useRootSelector(selectOptions);
  const defaultPurchasePath = newPaymentJourneyEnabled
    ? `/purchase/select-package?siteOptionIndex=${optionIndex}`
    : `/purchase/course-option/${optionIndex}`;
  const bookingLink = bookingOpen
    ? bookingLinkOverride || defaultPurchasePath
    : '';
  const openText =
    bookingButtonTextOverride ||
    (t('site.modules.course-option-display.cta.book-now.label') as string);
  const closedText =
    bookingClosedText ||
    (t('site.modules.course-option-display.cta.sold-out.label') as string);

  return (
    <Component
      data-testid={testId}
      label={bookingOpen ? openText : closedText}
      disabled={!bookingOpen}
      url={bookingLink}
    />
  );
}

BookButton.defaultProps = {
  testId: 'course-option-display-module-book-button',
};
